import { PORTRAITS, TENETS, TEXTURES } from "../data/content";
import { Reveal, SectionHeading } from "./Reveal";

const Ethos = () => (
  <section id="ethos" data-testid="healing-philosophy-section" className="relative py-20 sm:py-28 overflow-hidden">
    <div
      className="absolute inset-0 opacity-[0.05] bg-cover bg-center pointer-events-none"
      style={{ backgroundImage: `url(${TEXTURES.botanical})` }}
    />
    <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
      <SectionHeading number="03" title="Healing Philosophy" testId="healing-philosophy-heading" />

      <div className="grid lg:grid-cols-12 gap-12 items-center mb-16">
        <Reveal className="lg:col-span-7">
          <blockquote data-testid="ethos-quote-block">
            <p className="font-display italic text-2xl sm:text-3xl lg:text-4xl text-[#0D3B3E] leading-[1.25] tracking-tight">
              &ldquo;The highest ideal of cure is the rapid, gentle and permanent restoration of health.&rdquo;
            </p>
            <footer className="mt-6 text-[10px] font-mono tracking-[0.22em] text-[#0D9488]">
              — DR. SAMUEL HAHNEMANN · ORGANON OF MEDICINE
            </footer>
          </blockquote>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-5">
          <figure data-testid="ethos-portrait-fig02" className="portrait-frame relative max-w-xs mx-auto lg:ml-auto">
            <div className="overflow-hidden">
              <img
                src={PORTRAITS.desk}
                alt="Dr. Mugdha Adhikari at the consulting desk"
                className="w-full aspect-[3/4] object-cover object-top"
                loading="lazy"
              />
            </div>
            <figcaption className="flex items-center justify-between mt-4">
              <span className="text-[10px] font-mono tracking-[0.2em] text-slate-500">FIG. 02 — AT THE CONSULTING DESK</span>
            </figcaption>
          </figure>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 gap-5">
        {TENETS.map((t, i) => (
          <Reveal key={t.num} delay={i * 0.07}>
            <article
              data-testid={`ethos-tenet-card-${i}`}
              className="group h-full bg-white/80 backdrop-blur border border-[#0D3B3E]/10 p-7 sm:p-9 transition-[border-color,transform] duration-500 hover:border-[#0D9488]/50 hover:-translate-y-1"
            >
              <p className="text-xs font-mono tracking-[0.25em] text-[#0D9488] mb-4">{t.num}</p>
              <h3 className="font-display font-semibold text-xl sm:text-2xl text-[#0D3B3E] tracking-tight">{t.title}</h3>
              <p className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">{t.desc}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Ethos;
